export function OptionIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M10.3712 6.05917C11.4341 5.85448 12.1299 4.82685 11.9252 3.76391C11.7205 2.70096 10.6929 2.0052 9.62992 2.20989C8.56697 2.41459 7.87122 3.44221 8.07591 4.50516C8.2806 5.56811 9.30823 6.26386 10.3712 6.05917Z" />
      <path d="M10 11.96C11.0825 11.96 11.96 11.0825 11.96 10C11.96 8.91752 11.0825 8.04 10 8.04C8.91752 8.04 8.04 8.91752 8.04 10C8.04 11.0825 8.91752 11.96 10 11.96Z" />
      <path d="M10 17.83C11.0825 17.83 11.96 16.9525 11.96 15.87C11.96 14.7875 11.0825 13.91 10 13.91C8.91752 13.91 8.04 14.7875 8.04 15.87C8.04 16.9525 8.91752 17.83 10 17.83Z" />
    </svg>
  )
}
